export default __webpack_public_path__ + "static/media/Box.01e4fe69.svg";